/**
 * Dependency injection data
 */
import {InjectionToken} from "@angular/core";
import {ModuleConfig} from "./models/moduleConfig";

export const COMMON_MODULE_CONFIG_TOKEN = new InjectionToken<ModuleConfig>('COMMON_MODULE_CONFIG');
